import './StaticStringInput.css';

import {
  FilterType,
  NavigationForm,
  StaticStringControl,
} from '../../../../../types/types';
import { Link } from 'react-router-dom';
import useRoutes from '../../../../../hooks/useRoutes';
import { resolveDecorator } from '../../utils/resolveDecorator';
import { getDisplayValue } from './utils/getDisplayValue';

interface StaticStringInputProps {
  value: string | null;
  control: StaticStringControl;
  type?: FilterType;
}

const STATIC_STRING_CLASSNAME = 'static-string';
const STATIC_STRING_CONTENT_CLASSNAME = 'static-string-content';
const STATIC_STRING_DECORATOR_CLASSNAME = 'static-string-decorator';

const StaticStringInput = ({
  value,
  control,
  type,
}: StaticStringInputProps) => {
  const routes = useRoutes();
  const action = control.action;
  const resolvedDecorator = resolveDecorator(control.decorator);
  const displayValue = getDisplayValue(value, type);

  // Static values use a dedicated decorator slot to avoid overlapping the main content text.
  const decorator = resolvedDecorator ? (
    <span className={STATIC_STRING_DECORATOR_CLASSNAME}>
      {resolvedDecorator}
    </span>
  ) : null;

  if (action) {
    if (action.type === 'link') {
      return (
        <span className={STATIC_STRING_CLASSNAME}>
          <a
            href={action.template}
            target={action.target || '_self'}
            title={action.hint || displayValue || ''}
            className={STATIC_STRING_CONTENT_CLASSNAME}
          >
            {displayValue}
          </a>
          {decorator}
        </span>
      );
    }
    //TODO: Fix form links after implementing proper client side routing
    const path =
      action.type === 'dataset'
        ? `${routes.home()}${action.datasetId}`
        : `${routes.home()}${action.formId}`;

    return (
      <span className={STATIC_STRING_CLASSNAME}>
        <Link
          target={(action as NavigationForm).target || '_self'}
          to={path}
          className={STATIC_STRING_CONTENT_CLASSNAME}
          title={(action as NavigationForm).hint || displayValue || ''}
        >
          {displayValue}
        </Link>
        {decorator}
      </span>
    );
  }

  return (
    <span className={STATIC_STRING_CLASSNAME}>
      <span className={STATIC_STRING_CONTENT_CLASSNAME}>{displayValue}</span>
      {decorator}
    </span>
  );
};

export default StaticStringInput;
